import './Publications.css';
import { storeVisitorLocation } from '../../utils/visitor-tracker';
import { LOCATIONS_ENUM } from '../../hooks-store/stores/visitor-map';
import { useStore } from '../../hooks-store/store';
import { useEffect } from 'react';
import GenericBox from '../ProfileBoxes/GenericBox/GenericBox';
import Publication from './Publication/Publication';
import TagBubble from '../TagBubble/TagBubble';

const Publications = () => {
    const visitorToken = useStore(false)[0].visitorToken;

    useEffect(() => {
        visitorToken && storeVisitorLocation(visitorToken, LOCATIONS_ENUM.PUBLICATIONS);
    }, []);

    return (
        <GenericBox title="Publications" rowSpan={1} columnSpan={4} titleType="subtitle">
            <Publication
                title="Algorithms of adaptation in inductive inference."
                authorString="JP. Fränken, N. C. Theodoropoulos, N. R. Bramley"
                year="2022"
                journal="Cognitive Psychology"
                tags={[<TagBubble key="1" title="Project" link="https://doi.org/10.1016/j.cogpsych.2022.101506" />,
                <TagBubble key="112" title="Experiment 1" link="https://zendo-cond-3.herokuapp.com/signup" />, <TagBubble key="2" title="Repo" link="https://github.com/NikTheGeek1/zendo-cond-3" />]}
            />
            <Publication
                title="Belief revision in a micro-social network: Modelling sensitivity to statistical dependencies in social learning."
                authorString="JP. Fränken, N. C. Theodoropoulos, A. B. Moore, N. R. Bramley"
                year="2020"
                journal="Proceedings of the 42nd Annual Meeting of the Cognitive Science Society 2020"
                tags={[<TagBubble key="3" title="Project" link="https://cogsci.mindmodeling.org/2020/papers/0240/0240.pdf" />, <TagBubble key="4" title="Repo" link="https://github.com/NikTheGeek1/belief-revision-experiment-2" />]}
            />
            <Publication
                title="External coding and salience in the tactile Simon Effect."
                authorString="J. Medina, N. Theodoropoulos, Y. Liu, P.G. Reyesa, E. Gherri"
                year="2019"
                journal="Acta Psychologica Vol. 198"
                tags={<TagBubble key="5" title="Project" link="https://doi.org/10.1016/j.actpsy.2019.102874" />}
            />
        </GenericBox>
    );
};

export default Publications;